import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointUpdateProtectResourcesModel extends SharePointResourcesBaseModel {
  learningEnd: Date;
}
